import { useState, useEffect, useCallback, useRef } from 'react';
import ReactPlayer from 'react-player'

import '../../Styles/ArtistRoot.css';
import { useParams, Link } from 'react-router-dom';
import { AiOutlinePlusCircle, AiOutlineClose } from 'react-icons/ai';
import { MdEdit, MdCheck, MdCheckCircle, MdCancel, MdDelete, MdPlayArrow } from 'react-icons/md';
import Carousel from '../../component/Carousel';
import { Formik } from 'formik';
import * as Yup from 'yup';
import PostViewModal from './components/PostViewModal';
import { RiCheckboxFill, RiCheckboxBlankLine } from 'react-icons/ri';
import izenuAPI from '../../services/izenuAPI';
import { OverviewTab, FinanceTab, EarningsTab, BankTab, useArtistFinance } from './ArtistTabs';
import AudienceTab from './ArtistAudienceTab';
import UpdatePwd from './components/UpdatePwd';
import GENRES from '../../utils/Genres';

const PlaylistItem = ({ data: e, musicId, closeModal }) => {
    const [check, setCheck] = useState(false);
    const handleChange = useCallback(async () => {

        if (check == false) {
            const { data: r } = await izenuAPI.post('/playlist_musics/createPlaylistMusics.php', {
                playlistId: e.id,
                musicId: musicId,
            });
            console.log(r);
            setCheck(true);
            closeModal(false);
        } else {
            setCheck(false);
            closeModal(false);
        }

    });
    return (<button onClick={() => handleChange()} style={{ padding: 10, display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
        {check ? (
            <RiCheckboxFill size={30} color="#3992ff" />
        ) : (
            <RiCheckboxBlankLine size={30} color="#172b4d" />
        )}

        {e.title}
    </button>);
};

const Player = ({ musicPlayer, playing, setPlaying }) => {


    /*useEffect(()=>{
        if(musicPlayer!= null){

        
        if(musicPlayer.title != music.title && musicPlayer!= null){
            setPlaying(true);
        }
    }   
    },[musicPlayer])*/

    const handleMusicCover = useCallback((cover) => {
        if (cover == null || cover == undefined) {
            return (
                <div style={{ width: 45, backgroundColor: "#777", height: 45, borderRadius: 4 }}>

                </div>);
        } else {
            return (
                <img class="w-8 h-8 border" src={cover.photo_low_quality_url} />

            );
        }
    });

    if (musicPlayer != null) {
        return (<div class="border  w-full ">
            <ul class="w-full bg-gray-900">
                <li class="pb-3 sm:pb-4">
                    <div class="flex items-center space-x-4 rtl:space-x-reverse">
                        <div class="flex-shrink-0">
                            {handleMusicCover(musicPlayer.cover)}
                        </div>
                        <div class="flex-1 min-w-0">
                            <p class="text-sm font-medium text-gray-100 truncate ">
                                {musicPlayer.title}
                            </p>
                            <p class="text-sm text-gray-200 truncate">
                                {musicPlayer.singer}

                            </p>
                        </div>
                        <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                            {playing ? (
                                <span onClick={() => {
                                    if (playing) {
                                        setPlaying(false);
                                    }
                                }} class="rounded-full cursor-pointer flex items-center justify-center w-7 h-7 bg-amber-500">
                                    <svg class="w-4 h-4 text-gray-800 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                        <path fill-rule="evenodd" d="M8 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H8Zm7 0a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1Z" clip-rule="evenodd" />
                                    </svg>

                                </span>
                            ) : (
                                <span onClick={() => {

                                    setPlaying(true);

                                }} class="rounded-full cursor-pointer flex items-center justify-center w-7 h-7 bg-amber-500">
                                    <svg class="w-4 h-4 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                        <path fill-rule="evenodd" d="M8.6 5.2A1 1 0 0 0 7 6v12a1 1 0 0 0 1.6.8l8-6a1 1 0 0 0 0-1.6l-8-6Z" clip-rule="evenodd" />
                                    </svg>


                                </span>
                            )}

                        </div>
                    </div>

                </li>
            </ul>
            <ReactPlayer
                className='react-player'
                url={musicPlayer.music_url}
                width='100%'
                height='100%'
                playing={playing}
            />

        </div>)
    }
    return null;
}
// Profile photos are resized server-side up to 1200 px (ImageOptimizer 'music').
const PHOTO_MAX_MB = 10;

export default function Artist() {
    const [music, setMusic] = useState([]);
    const [details, setDetails] = useState([]);
    const [playlists, setPlaylists] = useState([]);
    const [musicId, setMusicId] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [countPlaylists, setCountPlaylists] = useState(0);
    const [updatePhotoModal, setUpdatePhotoModal] = useState(false);
    const [playing, setPlaying] = useState(false);
    const [musicPlayer, setMusicPlayer] = useState(null);
    const [photo, setPhoto] = useState(null);
    const [userPosts, setUserPosts] = useState([]);
    const [showViewPost, setShowViewPost] = useState(false);
    const [postId, setPostId] = useState(null);

    const [showUpdatePwd, setShowUpdatePwd] = useState(false);
    //load posts 
    const [loadPosts, setLoadPosts] = useState(true);

    //Upload post files
    const [postFiles, setPostFiles] = useState([]);

    const [loading, setLoading] = useState(true);
    const [releases, setReleases] = useState([]);

    // Edit artist states
    const [editingArtist, setEditingArtist] = useState(false);
    const [editFields, setEditFields] = useState({});
    const [savingArtist, setSavingArtist] = useState(false);

    //Create post modal
    const [postModal, setPostModal] = useState(false);

    let { artist_id } = useParams();
    // Same sections as the artist's web studio. Kept in ?tab= so a reload or a
    // shared link opens the same one.
    const [tab, setTabState] = useState(() => new URLSearchParams(window.location.search).get('tab') || 'music');
    const setTab = useCallback((t) => {
        setTabState(t);
        const url = new URL(window.location.href);
        url.searchParams.set('tab', t);
        window.history.replaceState(null, '', url);
    }, []);
    const finance = useArtistFinance(artist_id);
    // A tab the artist has no access to falls back to Músicas.
    const INSIGHT_TABS = ['overview', 'audience', 'finance'];
    const shownTab = finance.disabled && INSIGHT_TABS.includes(tab) ? 'music' : tab;

    const fetchPosts = useCallback(async () => {
        //fetch UserProfile photos
        const { data: resp } = await izenuAPI.get("/distributor/artist/fetchPosts.php?user_id=" + artist_id);
        if (resp.response) {
            setUserPosts(resp.data);
        }

    }, [artist_id]);

    //Fetcch artist data
    const fetchArtistDetails = useCallback(async () => {
        const distributor_id = localStorage.getItem('id');
        const END_POINT = `/distributor/artist/fetchArtistDetails.php?artist_id=${artist_id}&distributor_id=${distributor_id}`;
        const { data: r } = await izenuAPI.get(END_POINT);
        const { data: lists } = await izenuAPI.get(`/distributor/playlists/listByUserId.php?userId=${artist_id}`);

        setPlaylists(lists);

        if (r.response) {
            setDetails(r.artist_details);
            setMusic(r.songs);
            setCountPlaylists(r.total_playlists);
        }

        // Fetch releases (discography)
        try {
            const { data: relData } = await izenuAPI.get(`/release/fetchArtistReleases.php?artistId=${artist_id}&limit=100&include_drafts=1`);
            if (relData.response) {
                setReleases(relData.data);
            }
        } catch (e) {
            console.log('Error fetching releases', e);
        }

        setLoading(false);
    }, [artist_id]);

    const normalizeDateForInput = useCallback((dateStr) => {
        if (!dateStr) return '';
        const parts = dateStr.split('-');
        if (parts.length !== 3) return dateStr;
        const [y, m, d] = parts;
        return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
    }, []);

    const handleStartEditArtist = useCallback(() => {
        setEditFields({
            artist_name: details.artist_name || details.name || '',
            first_name: details.first_name || '',
            last_name: details.last_name || '',
            real_name: details.real_name || '',
            gender: details.gender || '',
            genre: details.genre || '',
            isni: details.isni || '',
            bio: details.bio || '',
            email: details.email || '',
            phone: details.phone || '',
            birthdate: normalizeDateForInput(details.birthdate),
            active: details.active !== undefined && details.active !== null ? String(details.active) : '1',
        });
        setEditingArtist(true);
    }, [details, normalizeDateForInput]);

    const handleSaveArtist = useCallback(async () => {
        setSavingArtist(true);
        try {
            const { data: r } = await izenuAPI.post('/distributor/artist/updateArtistDetails.php', {
                artist_id: parseInt(artist_id),
                ...editFields,
                active: parseInt(editFields.active)
            });
            if (r.response) {
                setEditingArtist(false);
                fetchArtistDetails();
            } else {
                alert('Erro: ' + (r.message || 'Falha ao guardar'));
            }
        } catch (err) {
            console.log(err);
            alert('Erro ao guardar alterações');
        }
        setSavingArtist(false);
    }, [artist_id, editFields, fetchArtistDetails]);

    const handleEditField = useCallback((field, value) => {
        setEditFields(prev => ({ ...prev, [field]: value }));
    }, []);

    //delete music
    const deleteSong = async (song) => {
        if (!window.confirm(`Apagar "${song.title}"? Esta acção não pode ser desfeita.`)) return;
        try {
            const { data: r } = await izenuAPI.post("/distributor/artist/deleteMusic.php", { music_id: song.music_id });
            if (r.response) {
                setMusic(list => list.filter(m => m.music_id !== song.music_id));
                if (musicPlayer?.music_id === song.music_id) { setPlaying(false); setMusicPlayer(null); }
            } else {
                alert(r.message || "Não foi possível apagar a música, tenta mais tarde.");
            }
        } catch (error) {
            console.log(error);
            // 409: the song has plays, purchases or a report; the server says which.
            alert(error?.response?.data?.message || "Não foi possível apagar a música, tenta mais tarde.");
        }
    };
    //Fetch all data
    useEffect(() => {
        fetchPosts();
        fetchArtistDetails();
    }, [artist_id]);

    //handle posts views
    const handlePostsView = useCallback(() => {
        if (userPosts.length > 0) {
            return (
                <div class="grid grid-cols-3 overflow-y-auto h-1/2">
                    <div className="aspect-square flex justify-center items-center bg-gray-100">
                        <button onClick={() => {
                            setSelectedImages([]);
                            setPostModal(true)

                        }} className="border-2 text-amber-500 border-dark-500">
                            Adicionar publicação
                        </button>
                    </div>
                    {userPosts.map((e, i) => {

                        if (e.file_type == 'mp4') {
                            return (
                                <div onClick={() => {
                                    setPostId(e.post_id);
                                    setShowViewPost(true);
                                }} className="aspect-square bg-gray-200 cursor-pointer active:opacity-50">

                                    <video className='w-full h-full object-cover'>
                                        <source src={e.video} />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            )
                        } else {
                            return (
                                <div onClick={() => {
                                    setPostId(e.post_id);
                                    setShowViewPost(true);
                                }} className="aspect-square bg-gray-200 cursor-pointer active:opacity-50">
                                    <img src={e.photo} className='w-full h-full object-cover' />
                                </div>
                            )
                        }
                    })}


                </div>
            )
        } else {
            return (<div class="grid grid-cols-3 overflow-y-auto h-1/2">
                <div className="aspect-square flex justify-center items-center bg-gray-100">
                    <button onClick={() => setPostModal(true)} className="border-2 text-amber-500 border-amber-500">
                        Adicionar publicação
                    </button>
                </div>

            </div>)
        }
    }, [userPosts]);

    const handleMusicCover = (cover) => (
        cover?.photo_low_quality_url
            ? <img className="h-11 w-11 rounded object-cover" src={cover.photo_low_quality_url} alt="" loading="lazy" />
            : <div className="h-11 w-11 rounded bg-gray-200" />
    );

    const handleMusicState = (state) => {
        const styles = {
            approved: ['Aprovada', 'bg-blue-50 text-blue-700 border-blue-200'],
            rejected: ['Rejeitada', 'bg-rose-50 text-rose-700 border-rose-200'],
        };
        const [label, cls] = styles[state] || ['Pendente', 'bg-amber-50 text-amber-700 border-amber-200'];
        return <span className={`rounded border px-2 py-0.5 text-xs font-semibold ${cls}`}>{label}</span>;
    };

    const handleChangeTrackState = useCallback(async (musicId, state) => {
        try {
            const { data: r } = await izenuAPI.post('/music/changeState.php', {
                music_id: musicId,
                state: state
            });
            if (r.response) {
                fetchArtistDetails();
            } else {
                alert('Erro ao alterar estado da música');
            }
        } catch (err) {
            console.log(err);
            alert('Erro ao alterar estado da música');
        }
    }, [fetchArtistDetails]);

    const uploadPhoto = useCallback(async () => {
        if (!photo) {
            setPhotoError('Escolhe uma imagem primeiro.');
            return;
        }
        setUploadingPhoto(true);

        const formData = new FormData();
        formData.append('file', photo);
        formData.append('user_id', details.user_id);

        try {
            // No manual Content-Type: axios must set the multipart boundary itself.
            const { data: r } = await izenuAPI.post('/distributor/artist/updateProfilePhoto.php', formData);

            if (r.response) {
                setUpdatePhotoModal(false);
                setPhoto(null);
                setPhotoPreview(null);
                fetchArtistDetails(); // Refresh to show new photo
                // setDetails(prev => ({...prev, photo: r.files.original})); // Optimistic update if needed
            } else {
                setPhotoError(r.message || 'Não foi possível actualizar a foto.');
            }
        } catch (error) {
            console.error(error);
            setPhotoError('Erro ao enviar a imagem. Tenta novamente.');
        }
        setUploadingPhoto(false);
    }, [photo, details, fetchArtistDetails]);

    const [photoError, setPhotoError] = useState('');
    const [photoPreview, setPhotoPreview] = useState(null);
    const [uploadingPhoto, setUploadingPhoto] = useState(false);

    useEffect(() => () => { if (photoPreview) URL.revokeObjectURL(photoPreview); }, [photoPreview]);

    const handlePhotoChange = useCallback((event) => {
        const file = event.currentTarget.files[0];
        setPhoto(null);
        setPhotoPreview(null);
        setPhotoError('');
        if (!file) return;

        // Case-insensitive: phones and cameras name files IMG_1234.PNG / .JPG.
        const ext = (file.name.split('.').pop() || '').toLowerCase();
        if (!['jpg', 'jpeg', 'png'].includes(ext)) {
            setPhotoError('Formato não suportado. Usa uma imagem JPG ou PNG.');
            return;
        }
        if (file.size > PHOTO_MAX_MB * 1024 * 1024) {
            setPhotoError(`A imagem tem ${(file.size / 1024 / 1024).toFixed(1)} MB. O máximo é ${PHOTO_MAX_MB} MB.`);
            return;
        }
        setPhoto(file);
        setPhotoPreview(URL.createObjectURL(file));
    }, []);

    //Handle input files
    const handlePostfileInput = useCallback((file) => {

        if (file) {

            setPostFiles([...postFiles, file]);
        }
    }, [postFiles]);

    const [selected, setSelected] = useState([]);

    const [selectedImages, setSelectedImages] = useState([]);
    const onChangeInput = useCallback((event) => {
        const selectedFiles = event.target.files;
        const selectedFilesArray = Array.from(selectedFiles);

        const imagesArray = selectedFilesArray.map((file) => {
            return URL.createObjectURL(file);
        });

        setSelectedImages((previousImages) => previousImages.concat(imagesArray));

        // FOR BUG IN CHROME
        event.target.value = "";
    });
    //Show post files
    const handlePostFilesView = useCallback(() => {

        if (selectedImages.length > 0) {

            return (
                <div class="flex flex-1 flex-row border border-amber-500">
                    {selectedImages.map((image, index) => {
                        return (

                            <img src={image} className='flex-1 aspect-square' alt="upload" />

                        );
                    })}
                </div>
            )
        } else {
            return (<h1 className='text-gray-500'>As fotos e videos que selecionara apareceram aqui</h1>)
        }

    }, [selectedImages]);

    //Loader
    if (loading) {
        return (<div className="justify-center block items-center flex flex-col h-full flex-1 p-5 rounded-lg" style={{ height: '100%' }}>
            <div role="status">
                <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-yellow-400" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                </svg>
                <h1 className="text-amber-500 font-light text-3xl">A carregar...</h1>
            </div>
        </div>)
    }


    const isInactive = Number(details.active) === 0;
    const genreNames = GENRES.map(g => g.name);
    const genreOptions = editFields.genre && !genreNames.includes(editFields.genre) ? [editFields.genre, ...genreNames] : genreNames;
    const editField = (key, label, input, wide) => (
        <label className={`block ${wide ? 'sm:col-span-2 lg:col-span-3' : ''}`}>
            <span className="mb-1 block text-sm font-medium text-gray-700">{label}</span>
            {input}
        </label>
    );
    const inputCls = 'block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-amber-500 focus:ring-amber-500';

    return (<>
        <div className="relative mx-auto max-w-6xl p-3 sm:p-6 text-left space-y-6">

            <Player musicPlayer={musicPlayer} playing={playing} setPlaying={setPlaying} />

            {/* Perfil */}
            <section className="rounded-xl border border-gray-200 bg-white p-4 sm:p-6">
                <div className="flex flex-col gap-5 sm:flex-row">
                    <div className="group relative mx-auto h-32 w-32 shrink-0 overflow-hidden rounded-xl bg-gray-200 sm:mx-0 sm:h-40 sm:w-40">
                        {details?.photo ? (
                            <img className="h-full w-full object-cover" src={`${process.env.REACT_APP_CDN_URL}/users/${details.user_id}/profile_photos/${details.photo}`} alt="" />
                        ) : (
                            <svg className="h-full w-full p-6 text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <path stroke="currentColor" strokeWidth="1.5" d="M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                            </svg>
                        )}
                        <button onClick={() => setUpdatePhotoModal(true)} type="button"
                            className="absolute inset-x-0 bottom-0 bg-black/60 py-1.5 text-xs font-medium !text-white hover:bg-black/75">
                            Alterar foto
                        </button>
                    </div>

                    <div className="min-w-0 flex-1">
                        {editingArtist ? (
                            <form onSubmit={(e) => { e.preventDefault(); handleSaveArtist(); }} className="space-y-4">
                                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
                                    {editField('artist_name', 'Nome artístico', <input className={inputCls} value={editFields.artist_name} onChange={(e) => handleEditField('artist_name', e.target.value)} required />)}
                                    {editField('first_name', 'Primeiro nome', <input className={inputCls} value={editFields.first_name} onChange={(e) => handleEditField('first_name', e.target.value)} />)}
                                    {editField('last_name', 'Último nome', <input className={inputCls} value={editFields.last_name} onChange={(e) => handleEditField('last_name', e.target.value)} />)}
                                    {editField('real_name', 'Nome real', <input className={inputCls} value={editFields.real_name} onChange={(e) => handleEditField('real_name', e.target.value)} />)}
                                    {editField('email', 'Email', <input type="email" className={inputCls} value={editFields.email} onChange={(e) => handleEditField('email', e.target.value)} />)}
                                    {editField('phone', 'Telefone', <input type="tel" className={inputCls} value={editFields.phone} onChange={(e) => handleEditField('phone', e.target.value)} />)}
                                    {editField('genre', 'Género musical', (
                                        <select className={inputCls} value={editFields.genre} onChange={(e) => handleEditField('genre', e.target.value)}>
                                            <option value="">Sem género</option>
                                            {genreOptions.map(g => <option key={g} value={g}>{g}</option>)}
                                        </select>
                                    ))}
                                    {editField('gender', 'Sexo', (
                                        <select className={inputCls} value={editFields.gender} onChange={(e) => handleEditField('gender', e.target.value)}>
                                            <option value="">—</option>
                                            <option value="male">Masculino</option>
                                            <option value="female">Feminino</option>
                                        </select>
                                    ))}
                                    {editField('birthdate', 'Data de nascimento', <input type="date" className={inputCls} value={editFields.birthdate} onChange={(e) => handleEditField('birthdate', e.target.value)} />)}
                                    {editField('isni', 'ISNI', <input className={inputCls} value={editFields.isni} onChange={(e) => handleEditField('isni', e.target.value)} placeholder="0000 0000 0000 0000" />)}
                                    {editField('active', 'Conta', (
                                        <select className={inputCls} value={editFields.active} onChange={(e) => handleEditField('active', e.target.value)}>
                                            <option value="1">Activa</option>
                                            <option value="0">Desactivada</option>
                                        </select>
                                    ))}
                                    {editField('bio', 'Biografia', <textarea rows={4} className={`${inputCls} resize-y`} value={editFields.bio} onChange={(e) => handleEditField('bio', e.target.value)} />, true)}
                                </div>
                                <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
                                    <button type="button" onClick={() => setEditingArtist(false)} disabled={savingArtist}
                                        className="rounded-lg !border !border-solid border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50">Cancelar</button>
                                    <button type="submit" disabled={savingArtist}
                                        className="flex items-center justify-center gap-1 rounded-lg bg-amber-500 px-4 py-2.5 text-sm font-medium !text-white hover:bg-amber-600 disabled:opacity-50">
                                        <MdCheck size={16} /> {savingArtist ? 'A guardar…' : 'Guardar alterações'}
                                    </button>
                                </div>
                            </form>
                        ) : (
                            <div className="space-y-2 text-center sm:text-left">
                                <div className="flex flex-wrap items-center justify-center gap-2 sm:justify-start">
                                    <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">{details.artist_name || details.name}</h1>
                                    {isInactive && <span className="rounded-full bg-red-50 px-2 py-0.5 text-xs font-semibold text-red-700">Conta desactivada</span>}
                                </div>
                                {details.real_name && <p className="text-sm text-gray-500">Nome real: {details.real_name}</p>}
                                <p className="text-sm text-gray-700">{music.length} {music.length === 1 ? 'música' : 'músicas'} · {countPlaylists} {Number(countPlaylists) === 1 ? 'playlist' : 'playlists'}{details.genre ? ` · ${details.genre}` : ''}</p>
                                {details.bio && <p className="text-sm text-gray-600 whitespace-pre-line">{details.bio}</p>}
                                {(details.email || details.phone) && (
                                    <p className="text-sm text-gray-500 break-all">{[details.email, details.phone].filter(Boolean).join(' · ')}</p>
                                )}
                                <div className="flex flex-wrap justify-center gap-2 pt-2 sm:justify-start">
                                    <button type="button" onClick={handleStartEditArtist}
                                        className="flex items-center gap-1.5 rounded-lg bg-amber-500 px-4 py-2 text-sm font-medium !text-white hover:bg-amber-600">
                                        <MdEdit size={16} /> Editar dados
                                    </button>
                                    <button type="button" onClick={() => setShowUpdatePwd(true)}
                                        className="rounded-lg !border !border-solid border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
                                        Alterar palavra-passe
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            {/* Sections */}
            <nav aria-label="Secções do artista" className="-mb-2 flex gap-5 overflow-x-auto border-b border-gray-200">
                {[['overview', 'Visão geral'], ['music', 'Músicas'], ['audience', 'Audiência'], ['finance', 'Vendas'], ['earnings', 'Ganhos'], ['bank', 'Dados bancários']]
                    .filter(([key]) => !finance.disabled || !INSIGHT_TABS.includes(key))
                    .map(([key, label]) => (
                    <button key={key} type="button" onClick={() => setTab(key)} aria-current={shownTab === key ? 'page' : undefined}
                        className={`-mb-px whitespace-nowrap border-b-2 pb-2.5 text-sm font-semibold ${shownTab === key ? 'border-amber-500 text-gray-900' : 'border-transparent text-gray-500 hover:text-gray-800'}`}>
                        {label}
                    </button>
                ))}
            </nav>

            {tab === 'overview' && !finance.disabled && <OverviewTab finance={finance} onGoTo={setTab} />}
            {tab === 'audience' && !finance.disabled && <AudienceTab artistId={artist_id} />}
            {tab === 'finance' && !finance.disabled && <FinanceTab finance={finance} onGoTo={setTab} />}
            {tab === 'earnings' && <EarningsTab artistId={artist_id} onGoTo={setTab} />}
            {tab === 'bank' && <BankTab artistId={artist_id} />}

            {shownTab === 'music' && (<>
            {/* Músicas */}
            <section className="rounded-xl border border-gray-200 bg-white">
                <div className="border-b px-4 py-3">
                    <h2 className="text-lg font-semibold text-gray-900">Músicas</h2>
                    <ul className="mt-2 space-y-0.5 text-xs [&_li]:!p-0 [&_li]:!text-gray-500">
                        <li className="flex items-start gap-1.5"><MdCheckCircle size={14} className="mt-px shrink-0 text-green-600" aria-hidden="true" />
                            <span><strong className="font-medium text-gray-700">Aprovar</strong> torna a música visível ao público. <strong className="font-medium text-gray-700">Rejeitar</strong> (<MdCancel size={12} className="inline text-red-600 align-[-1px]" aria-hidden="true" />) esconde-a em toda a Izenu, sem a apagar; podes voltar a aprová-la.</span></li>
                        <li className="flex items-start gap-1.5"><span className="mt-px w-[14px] shrink-0 text-center text-[11px] font-bold leading-[14px] text-amber-700" aria-hidden="true">+</span>
                            <span><strong className="font-medium text-gray-700">+ Playlist</strong> junta a música a uma das playlists deste artista.</span></li>
                        <li className="flex items-start gap-1.5"><MdDelete size={14} className="mt-px shrink-0 text-rose-600" aria-hidden="true" />
                            <span><strong className="font-medium text-gray-700">Apagar</strong> remove a música para sempre. Só é possível em músicas sem reproduções, sem compras e sem denúncias; nas outras, rejeita-a para a esconder.</span></li>
                        <li className="flex items-start gap-1.5"><MdPlayArrow size={14} className="mt-px shrink-0 text-gray-500" aria-hidden="true" />
                            <span>Toca no título ou na capa para ouvir.</span></li>
                    </ul>
                </div>
                {music && music.length > 0 ? (
                    <ul className="divide-y divide-gray-100">
                        {music.map((e) => {
                            const isPlaying = musicPlayer?.music_id === e.music_id && playing;
                            return (
                                <li key={e.music_id} className={`flex flex-wrap items-center gap-3 px-4 py-3 ${isPlaying ? 'bg-amber-50' : 'hover:bg-gray-50'}`}>
                                    <button type="button" onClick={() => { setMusicPlayer(e); setPlaying(true); }}
                                        className="flex min-w-0 flex-1 basis-56 items-center gap-3 text-left" aria-label={`Ouvir ${e.title}`}>
                                        {handleMusicCover(e.cover)}
                                        <span className="min-w-0">
                                            <span className="block truncate text-sm font-medium text-gray-900">{e.title}</span>
                                            <span className="block truncate text-xs text-gray-500">{e.singer || details.artist_name}</span>
                                        </span>
                                    </button>
                                    <div className="flex flex-wrap items-center gap-2">
                                        {handleMusicState(e.music_state)}
                                        {e.music_state !== 'approved' && (
                                            <button onClick={() => handleChangeTrackState(e.music_id, 'approved')} title="Aprovar" aria-label="Aprovar" className="rounded p-1 text-green-600 hover:bg-green-50">
                                                <MdCheckCircle size={20} />
                                            </button>
                                        )}
                                        {e.music_state !== 'rejected' && (
                                            <button onClick={() => handleChangeTrackState(e.music_id, 'rejected')} title="Rejeitar" aria-label="Rejeitar" className="rounded p-1 text-red-600 hover:bg-red-50">
                                                <MdCancel size={20} />
                                            </button>
                                        )}
                                        <button type="button" onClick={() => { setMusicId(e.music_id); setShowModal(true); }}
                                            className="rounded-lg !border !border-solid border-amber-400 px-2.5 py-1 text-xs font-medium text-amber-700 hover:bg-amber-50">
                                            + Playlist
                                        </button>
                                        <button type="button" onClick={() => deleteSong(e)}
                                            className="rounded-lg px-2.5 py-1 text-xs font-medium text-rose-600 hover:bg-rose-50">
                                            Apagar
                                        </button>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                ) : (
                    <p className="py-12 text-center text-sm text-gray-500">Este artista ainda não tem músicas.</p>
                )}
            </section>

            {/* Discografia */}
            <section>
                <h2 className="mb-3 text-lg font-semibold text-gray-900">Discografia</h2>
                {releases.length > 0 ? (
                    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                        {releases.map((rel) => {
                            const ext = (rel.artwork || '').split('.').pop()?.toLowerCase();
                            const coverUrl = rel.artwork && ['jpg', 'jpeg', 'png', 'webp', 'gif'].includes(ext) ? rel.artwork : null;
                            return (
                                <Link key={rel.id} to={`/release/${rel.id}`} className="overflow-hidden rounded-xl border border-gray-200 bg-white transition-shadow hover:shadow-md">
                                    {coverUrl ? (
                                        <img src={coverUrl} alt="" loading="lazy" className="aspect-square w-full object-cover" />
                                    ) : (
                                        <div className="flex aspect-square w-full items-center justify-center bg-gray-200">
                                            <svg className="h-10 w-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
                                            </svg>
                                        </div>
                                    )}
                                    <div className="p-2.5">
                                        <p className="truncate text-sm font-medium text-gray-900">{rel.title}</p>
                                        <div className="mt-1 flex flex-wrap items-center gap-1.5">
                                            <span className="text-xs text-gray-500">{({ album: 'Álbum', ep: 'EP', single: 'Single' })[rel.type] || rel.type}</span>
                                            <span className="text-xs text-gray-400">{rel.track_count} {Number(rel.track_count) === 1 ? 'faixa' : 'faixas'}</span>
                                            <span className={`rounded px-1.5 py-0.5 text-xs ${rel.status === 'active' ? 'bg-green-100 text-green-700' : rel.status === 'takedown' ? 'bg-red-100 text-red-700' : 'bg-orange-100 text-orange-700'}`}>
                                                {rel.status === 'active' ? 'Activo' : rel.status === 'takedown' ? 'Takedown' : 'Rascunho'}
                                            </span>
                                        </div>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                ) : (
                    <p className="text-sm text-gray-500">Este artista ainda não tem álbuns nem singles.</p>
                )}
            </section>
            </>)}

            <UpdatePwd id={artist_id} show={showUpdatePwd} setShow={setShowUpdatePwd} />
        </div>
        <PostViewModal show={showViewPost} setShow={setShowViewPost} postId={postId} />
        {showModal ? (
            <div className="modal w-full">
                <div className="bg-gray-100 pb-5 px-5">
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: 12, alignItems: 'center' }}>
                        <h3>Salvar para</h3>
                        <button onClick={() => setShowModal(false)}>
                            <AiOutlineClose size={30} color="#172b4d" />
                        </button>
                    </div>
                    <div style={{ flex: 1, overflowY: 'scroll', overflowX: 'hidden' }}>
                        {playlists.length > 0 ? (
                            <>
                                {playlists.map((e, i) => {
                                    return (
                                        <PlaylistItem data={e} musicId={musicId} closeModal={setShowModal} />
                                    )
                                })}
                            </>
                        ) : (
                            <div className="">
                                <h1 class="text-gray-500 font-sm">Ainda não criou playlist para este utilizador</h1>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        ) : (<>
        </>)}

        {postModal ? (
            <div className="modal w-full">
                <div className="flex flex-col bg-gray-100 h-4/6 w-1/4 pt-10 overflow-hidden">
                    <div className='flex justify-between px-5'>
                        <div className='flex flex-1'>
                            <h1>Adicionar publicação</h1>
                        </div>

                        <button onClick={() => setPostModal(false)}>
                            <AiOutlineClose size={30} color="#172b4d" />
                        </button>
                    </div>
                    <div className='flex flex-1 flex-col'>
                        <div className='flex flex-1 w-full'>
                            <Carousel>
                                {selectedImages.map((e, i) => {
                                    return (<img src={e} className='flex-1 aspect-square' alt="upload" />)
                                })}
                            </Carousel>
                        </div>
                        <div className='py-5'>
                            {selectedImages.length == 0 ? (
                                <>
                                    <label for="files" className='bg-amber-500 px-5 py-2 cursor-pointer active:bg-amber-400'>
                                        Selecionar do computador
                                    </label>
                                    <input id="files" onChange={onChangeInput} multiple class="hidden" accept="image/gif, image/jpeg, image/jpg, video/mp4" type='file' />
                                </>
                            ) : (
                                <button className='bg-amber-500 px-5 py-2 cursor-pointer active:bg-amber-400'>
                                    Proximo
                                </button>
                            )}

                        </div>

                    </div>
                </div>
            </div>
        ) : (<></>)}


        {/**UPDATE FOTO MODAL */}
        {updatePhotoModal ? (
            <div style={{ backgroundColor: "#0005", height: '100%' }} class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex">
                <div class="relative p-4 w-full max-w-md max-h-full">
                    <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">

                        <div class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                            <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
                                Actualizar foto de perfil
                            </h3>
                            <button type="button" onClick={() => setUpdatePhotoModal(false)} class="end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="authentication-modal">
                                <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                                </svg>
                            </button>
                        </div>

                        <div class="p-4 md:p-5">
                            <form onSubmit={(e) => {
                                e.preventDefault();
                                uploadPhoto();
                            }} class="space-y-4" action="#">
                                {photoPreview && (
                                    <img src={photoPreview} alt="" className="mx-auto h-40 w-40 rounded-xl object-cover border" />
                                )}
                                <div>
                                    <input onChange={handlePhotoChange} accept="image/png, image/jpeg" id="photo" name="photo" type="file" className="block w-full text-sm focus:border-amber-500 text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none" aria-describedby="photo_help" />
                                    <ul id="photo_help" className="mt-2 space-y-0.5 text-left text-xs [&_li]:!p-0 [&_li]:!text-gray-500">
                                        <li><strong className="font-medium text-gray-700">Formato:</strong> JPG ou PNG</li>
                                        <li><strong className="font-medium text-gray-700">Tamanho ideal:</strong> quadrada, 1200 × 1200 px ou mais (mínimo 640 × 640)</li>
                                        <li><strong className="font-medium text-gray-700">Peso máximo:</strong> {PHOTO_MAX_MB} MB</li>
                                        <li>A foto aparece em círculo na app; mantém o rosto ao centro.</li>
                                    </ul>
                                    {photoError && <p className="mt-2 text-left text-sm text-red-600">{photoError}</p>}
                                </div>

                                <button type="submit" disabled={!photo || uploadingPhoto} className="w-full !text-white bg-amber-500 hover:bg-amber-600 disabled:opacity-50 font-medium rounded-lg text-sm px-5 py-2.5 text-center">{uploadingPhoto ? 'A enviar…' : 'Actualizar foto'}</button>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <></>
        )}

    </>
    );
}